<template>
  <div>
    <SobreMi></SobreMi>
    <fotter></fotter>
  </div>
</template>
<script>
import SobreMi from "@/components/SobreMiCompontcopy.vue";
import fotter from "@/components/FotterComponent.vue";

export default {
  name: "trabajo",
  components: {
    SobreMi,
    fotter,
  },
};
</script>